import React from 'react';

import { Typography } from '@mui/material';
import cx from 'classnames';

import useStyles from './styles';

interface CardHeaderProps {
  text: string;
  className?: string;
  onClick?: () => {};
}

const CardHeader: React.FC<CardHeaderProps> = ({ text, className, onClick }) => {
  const classes = useStyles();

  return (
    <Typography
      variant="h3"
      className={cx(classes.header, className)}
      onClick={() => onClick && onClick()}
    >
      {text}
    </Typography>
  );
};

export default CardHeader;
